import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { subDays } from "date-fns";
import type { RootState } from "../store";

export type ReportType =
	| "ageAndGender"
	| "monthlyIncome"
	| "speciality"
	| "averagePerSession"
	| null;

export interface ReportsState {
	startDate: string;
	endDate: string;
	reportType: ReportType;
	status: "idle" | "loading" | "succeeded" | "failed";
	data: any;
}

const initialState: ReportsState = {
	startDate: subDays(new Date(), 89).toISOString(),
	endDate: new Date().toISOString(),
	reportType: "ageAndGender", // default value
	status: "idle",
	data: null,
};

const reportsSlice = createSlice({
	name: "reports",
	initialState,
	reducers: {
		setReportStartDate(state, action: PayloadAction<string>) {
			state.startDate = action.payload;
		},
		setReportEndDate(state, action: PayloadAction<string>) {
			state.endDate = action.payload;
		},
		setReportType(state, action: PayloadAction<ReportType>) {
			state.reportType = action.payload;
		},
		setReportStatus(state, action: PayloadAction<ReportsState["status"]>) {
			state.status = action.payload;
		},
		setReportData(state, action: PayloadAction<any>) {
			state.data = action.payload;
		},
		resetReportsState() {
			return initialState;
		},
	},
});

export const {
	setReportStartDate,
	setReportEndDate,
	setReportType,
	setReportStatus,
	setReportData,
	resetReportsState,
} = reportsSlice.actions;

// Selectors
export const selectReportStartDate = (state: RootState) =>
	state.reports.startDate;
export const selectReportEndDate = (state: RootState) => state.reports.endDate;
export const selectReportType = (state: RootState) => state.reports.reportType;
export const selectReportStatus = (state: RootState) => state.reports.status;
export const selectReportData = (state: RootState) => state.reports.data;

export default reportsSlice.reducer;
